import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { concatMap, map, catchError, of } from "rxjs";
import { MarketingAutomationClient } from "src/api-service";
import { normalizeError } from "../../../../app-store-error.types";
import { SendReminderActions } from "./send-reminder.actions";
import { environment } from "@env/environment";

@Injectable()
export class SendReminderEffects {
    private readonly actions$ = inject(Actions);
    private readonly marketingAutomationClient = inject(MarketingAutomationClient);

    sendReminder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SendReminderActions.send),
            concatMap(({ customerSystemId }) =>
                this.marketingAutomationClient.sendInactiveCustomerReminder(customerSystemId, {
                    companyId: environment.InactiveCustomersBCCompanyId,
                    environment: environment.InactiveCustomersBCEnvironment
                }).pipe(
                    map(result =>
                        SendReminderActions.sendSuccess({
                            customerSystemId,
                            result,
                            toastKey: "DEVELOPER.MARKETING_REMINDERS.SEND_SUCCESS",
                        }),
                    ),
                    catchError(error =>
                        of(
                            SendReminderActions.sendFailure({
                                customerSystemId,
                                error: normalizeError(error),
                                toastKey: "DEVELOPER.MARKETING_REMINDERS.SEND_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );
}
